/**
 * Generated by orval v7.7.0 🍺
 * Do not edit manually.
 * Backpac API
 * The Backpac API description
 * OpenAPI spec version: 1.0
 */

export type SettlementHistoryItemType = typeof SettlementHistoryItemType[keyof typeof SettlementHistoryItemType];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const SettlementHistoryItemType = {
  BGM: 'BGM',
  CAMPAIGN: 'CAMPAIGN',
  FACTORING_PAYOUT: 'FACTORING_PAYOUT',
} as const;
